import { HintWrapper, HintContent } from './DragHint.styles'

const HintIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8L22 12L18 16" />
    <path d="M6 8L2 12L6 16" />
    <line x1="2" y1="12" x2="22" y2="12" />
  </svg>
)

interface DragHintProps {
  label: string
  color?: string
  placeholder?: boolean
}

export const DragHint = ({ label, color, placeholder = false }: DragHintProps) => (
  <HintWrapper
    $placeholder={placeholder}
    style={color ? { color } : undefined}
    aria-hidden={placeholder || undefined}
  >
    <HintContent>
      <HintIcon />
      <span>{placeholder ? ' ' : label}</span>
    </HintContent>
  </HintWrapper>
)
